export default {
  get: {

  },
  post: {
    getMultiTypeList: "/group/get-multi-type-list", // 获取各种小列表接口
    getDistrictList: "/location/get-district-list", // 根据上级行政城市id获取行政城市列表
    getSystemConfig: "/system/config", // 公共下拉框
    getGroupInfo: "/group/get-group-info", //获取客户详情
  }
}